import { EMPTY_OBJ } from '~/core/shared/constants';
import { Nullable } from '~/core/shared/types';
import { Fields } from '~/core/shared/types/fields';
import {
  BOOLEAN_FIELD_NO_LABEL,
  BOOLEAN_FIELD_YES_LABEL,
} from '../constants/booleanFieldLabels';

export const getBooleanFieldLabels = (
  labels: Nullable<Fields.Boolean['meta']['labels']>,
) => {
  const {
    yes: truthyLabel = BOOLEAN_FIELD_YES_LABEL,
    no: falsyLabel = BOOLEAN_FIELD_NO_LABEL,
  } = labels ?? EMPTY_OBJ;

  return {
    truthyLabel,
    falsyLabel,
  };
};
